// extracted by mini-css-extract-plugin
module.exports = {"selectedPage":"Paginator_selectedPage__EwcK8","paginator":"Paginator_paginator__3OM_Y","pageNumber":"Paginator_pageNumber__1HZrj"};